import Home from "./components/Home";
import NavBar from "./components/NavBar"
import About from "./components/About";
import ProgressBar from 'react-progressbar-on-scroll'
import Projects from "./components/Projects";
import Footer from "./components/Footer";
function App() {
  return (
    <div className="App">
      <ProgressBar
        border="1px solid white"
        color="crimson"
        height={3}
        direction="right"
        position="top"
      />
      <NavBar />
      <Home />
      <About />
      <Projects />
      <Footer/>
    </div>
  );
}

export default App;
